import copyLinkIcon from 'public/static/images/copy-link.svg';
import { useTranslation } from 'react-i18next';
import css from 'styled-jsx/css';
import { colors, fonts } from 'components/styles/variables';
import { useState } from 'react';
import Icon from '../Icon';

function copyUrl(): void {
  const el = document.createElement('textarea');
  el.value = window.location.href;
  document.body.appendChild(el);
  el.select();
  document.execCommand('copy');
  document.body.removeChild(el);
}

const copyIconCss = css.resolve`
  .copy-icon {
    width: 22px;
    height: 22px;
    margin: 0;
  }
`;

interface CopyLinkItemProps {
  onClick: () => void;
}

function CopyLinkItem({ onClick = (): void => {} }: CopyLinkItemProps): JSX.Element {
  const { t } = useTranslation();
  const [linkCopied, setLinkCopied] = useState(false);

  return (
    <button
      className="icon-row copy-link-item-button"
      onClick={(): void => {
        onClick();
        copyUrl();
        setLinkCopied(true);
      }}
      data-testid="copy-link"
    >
      <div className="icon-container">
        <Icon className={`copy-icon ${copyIconCss.className}`} image={copyLinkIcon} />
      </div>
      <div className={linkCopied ? 'copied' : 'share-action'}>
        {linkCopied ? t('dealerPages.linkCopied') : t('dealerPages.copyLink')}
      </div>
      {copyIconCss.styles}
      <style jsx>{`
        .copy-link-item-button {
          margin: 0;
          padding: 0;
          background-color: white;
          border: none;
          cursor: pointer;
          font-family: ${fonts.default};
        }

        .copy-link-item-button:focus {
          outline: 0;
        }

        .icon-row {
          display: flex;
          align-items: center;
          box-sizing: border-box;
          width: 232px;
          height: 44px;
          padding: 6px 16px;
        }

        .icon-row:hover {
          background-color: ${colors.G1};
        }

        .icon-container {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 32px;
          height: 32px;
          margin-right: 14px;
        }

        .share-action {
          font-size: 16px;
          font-weight: 600;
          color: ${colors.BLACK};
        }

        .copied {
          font-size: 15px;
          font-weight: 600;
          letter-spacing: 0.2px;
          color: ${colors.G3};
        }
      `}</style>
    </button>
  );
}

export default CopyLinkItem;
